<template>
	<section class="main-content benefits">
		<div class="row">
			<div class="columns column5">
				<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
				<h2>{{ title }}</h2>
				<ul>
					<li v-for="(benefit, key) in benefits" :key="key">
						<span>{{ benefit }}</span>
					</li>
				</ul>
				<book-button class="button button-cta reserve-now right" aria-label="Reserve now" href="#">
					<span> {{ bookButtonLabel }}</span>
				</book-button>
				<!-- <a class="button button-cta reserve-now" href="#" target="_blank" rel="noopener noreferrer">
					{{ bookButton }}
				</a> -->
			</div>
		</div>
		<picture>
			<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
			<source :srcset="image" />
			<img class="fade-image" :src="image.image" :alt="image.imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	bookButtonLabel: { type: String, default: '' },
	benefits: { type: Array, default: () => [] },
	image: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.benefits .fade-image {
	opacity: 1;
}

.benefits {
	position: relative;
	padding: 75px 0;
}

.benefits .row {
	z-index: 2;
	position: relative;
}

.benefits .column5 {
	background: rgb(255 255 255 / 85%);
	backdrop-filter: blur(7px);
	padding: 60px 40px;
}

.benefits ul {
	list-style: none;
	font-size: 20px;
	margin: 30px 0;
	padding-left: 0;
}

.benefits li {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	margin: 20px 0;

	span {
		width: calc(100% - 70px);
	}
}

.benefits li::before {
	content: '';
	background: url('/images/icon-check.svg') no-repeat center center;
	background-size: 32px;
	height: 32px;
	width: 32px;
	display: block;
	margin: 0 30px 0 0;
}

@media (max-width: 1180px) {
	.benefits .column5 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.benefits .column5 {
		width: 100%;
	}
}

@media (max-width: 450px) {
	.benefits {
		position: relative;
		padding: 50px 0;
	}
}
</style>
